module.exports = __webpack_public_path__ + "static/img/428×188_logo.082af5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/428×188_logo.png
// module id = 373
// module chunks = 32